/**
 * Admin User Management Component
 * Standalone page for managing internal admin users
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { AdminPanelSettings as AdminIcon } from '@mui/icons-material';
import AdminUsersTab from './AdminUsersTab';
import { spacing } from '../../theme/designTokens';

export const AdminUserManagement: React.FC = () => {
  return (
    <Box sx={{ p: spacing[6], bgcolor: 'background.default', minHeight: '100vh' }}>
      <Box sx={{ mb: spacing[8] }}>
        <Typography variant="h1" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: spacing[3], mb: spacing[2] }}>
          <AdminIcon color="primary" sx={{ fontSize: 40 }} />
          Admin User Management
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.125rem' }}>
          Analytics, permissions, and administration for internal admin users
        </Typography>
      </Box>
      <AdminUsersTab />
    </Box>
  );
};

export default AdminUserManagement;
